exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n[data-v-1cc83830] .v-input--radio-group__input > .v-label {\n    left: -25px !important;\n    right: auto !important;\n    position: absolute !important;\n    max-width: 133%;\n    transform: translateY(-18px) scale(.75);\n}\n", ""]);

// exports
